import type {ReactElement} from 'react';
import React from 'react';
import {useGrapesjsEditor} from '@Components/email-maker-block-manager/email-maker-block-manager-grapesjs-editor-context';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {noop} from '@Utils/general.util';
import styles from './mobile-panel-header.module.scss';
import {setSelectedBlockPanel} from '@Components/email-maker-block-manager/email-maker-block-manager.reducer';
import {useAppDispatch} from '@/hooks';

interface MobilePanelHeaderProps {
  headerLabel: string;
  showHandleBar?: boolean;
  showBackButton?: boolean;
  onBackButton?: VoidFunction;
}

export function MobilePanelHeader({headerLabel, showHandleBar = false, showBackButton = false, onBackButton = noop}: MobilePanelHeaderProps): ReactElement {
  const gjsEditor = useGrapesjsEditor();
  const dispatch = useAppDispatch();

  const getHandleBar = (): ReactElement | null => {
    return showHandleBar ? <div className={styles.headerHandlebar}></div> : null;
  };

  const getBackButton = (): ReactElement => {
    return showBackButton ? (
      <Icon icon="icon-arrow-left" className={styles.mobileIcon} size={IconSize.SIZE_ICON_20} onClick={onBackButton} />
    ) : (
      <div className={styles.emptyIconContainer}></div>
    );
  };

  const getHeader = (): ReactElement => {
    return (
      <div className={styles.titleAndOptionsContainer}>
        {getBackButton()}
        <Text val={headerLabel} className="spacing-m-l-1" size={TextSize.SMALL} bold />
        <Icon
          icon="icon-close"
          className={styles.mobileIcon}
          size={IconSize.SIZE_ICON_20}
          onClick={() => {
            gjsEditor.runCommand(window.PMW.emails.commands.CLOSE_ADD_BLOCKS_DIALOG);
            dispatch(setSelectedBlockPanel(null));
          }}
        />
      </div>
    );
  };

  const getMobilePanelHeader = (): ReactElement => {
    return (
      <div className={styles.mobilePanelHeader}>
        {getHandleBar()}
        {getHeader()}
      </div>
    );
  };

  return getMobilePanelHeader();
}
